/**
 * Get metadata from spectra
 * @param spectra - Array of spectrum objects
 * @param options - Options for filtering spectra
 * @returns Array of metadata objects
 */
export function getMetadata(spectra, options = {}) {
    const { ids } = options;
    const metadata = [];
    if (Array.isArray(spectra) && spectra.length > 0) {
        for (const spectrum of spectra) {
            if (!ids || ids.includes(spectrum.id)) {
                metadata.push(spectrum.meta);
            }
        }
    }
    return metadata;
}
//# sourceMappingURL=getMetadata.js.map